import styled from 'styled-components';

export const ContentCardsContainer = styled.div`
  display: flex;
  align-items: center;
  overflow-x: scroll;
  padding-bottom: 16px;
  column-gap: 12px;

  @media (max-width: 720px) {
    padding: 0 12px 30px;
  }

  & ::-webkit-scrollbar {
    display: none;
  }
`;

export const OutterContainer = styled.div`
  margin-top: 1.5em;
  position: relative;
`;

export const ImageCard = styled.div`
  position: relative;
  cursor: pointer;
`;

export const Image = styled.img`
  width: 238px;
  height: 152px;
  border-radius: 6px;
  filter: brightness(0.6);
`;
export const ImageTag = styled.p`
  position: absolute;
  font-weight: 500;
  color: #fff;
  left: 50%;
  top: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
`;

export const Sliderarrow = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: ${(props) => (props.right ? '0' : 'auto')};
  left: ${(props) => (props.left ? '0' : 'auto')};
  top: 50%;
  z-index: 9;
  background: #fff;
  cursor: pointer;
  opacity: 0.7;
  padding: 4px;

  @media (max-width: 720px) {
    display: none;
  }
`;

export const Pinkrightarrow = styled.img`
  transform: ${(props) => (props.left ? 'rotate(180deg)' : 'rotate(0deg)')};
  width: ${(props) => (props.small ? '16px' : props.explore ? '12px' : 'auto')};
  height: ${(props) =>
    props.small ? '16px' : props.explore ? '12px' : 'auto'};
  margin-top: ${(props) => (props.small ? '4px' : 'auto')};
`;
